// Vendors
import $ from 'jquery';

if ($('.course__meta-date').length > 1) {
  $(document).on('ready', () => {
    // Create container for radio buttons to live in.
    const $emailFormFieldLabel = $(
      'form.wpcf7-form .grid--middle .grid__col-xs-12.grid__col-md-7.grid__col-lg-8'
    )
      .first()
      .find('.form__field > label');

    $emailFormFieldLabel.after('<div class="wpf7-radio-container" />');

    const $radioContainer = $('.wpf7-radio-container');
    let submitbuttonSpacer = 20;

    // Add dates to contact form as radio buttons.
    $('.course__meta-date').each((index, element) => {
      const theDate = element.innerText;
      const isInPast = $(element).hasClass('course__meta-date--past');
      submitbuttonSpacer += 28;

      $radioContainer.append(`<div class="form__field u--margin-bottom-0">
        <label class="form__radio-wpcf7-dates form__radio ${
          isInPast ? 'form__radio--disabled' : ''
        }" for="wpcf7__date-radio--${index}">
          <input id="wpcf7__date-radio--${index}" type="radio" name="course-date-radio" ${
        !index && !isInPast ? 'checked' : ''
      } ${isInPast ? 'disabled' : ''}>
            ${theDate}
        </label>
      </div>`);
    });

    // Add some top-spacing to submit button, or else it looks weird.
    const $submitButtonFormField = $(
      'form.wpcf7-form .grid--middle .grid__col-xs-12.grid__col-md-5.grid__col-lg-4'
    )
      .last()
      .find('.form__field');

    $submitButtonFormField.css({ marginTop: `${submitbuttonSpacer}px` });

    // Add/rm spacing depending on viewport width.
    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        $submitButtonFormField.css({ marginTop: `${submitbuttonSpacer}px` });
      } else {
        $submitButtonFormField.css({ marginTop: 0 });
      }
    });
  });

  // Overwrite CF7 hidden fields when radio btn selection changes.
  $(document).on('click', '.form__radio-wpcf7-dates', event => {
    event.preventDefault();

    const $this = $(event.currentTarget);

    if ($this.hasClass('form__radio--disabled')) return;

    const thisDate = event.currentTarget.innerText;

    // Overwrite hidden field.
    $('input[name=course_date]').val(thisDate);

    // Toggle input state.
    $this.find('input').prop('checked', true);
  });
}
